import React, { useEffect, useState } from 'react';
import { X, Sparkles } from 'lucide-react';
import { profileApi } from '../../services/api';
import useAuthStore from '../../store/useAuthStore';

// Re-engagement in-app notice. Rendered from the launch-time /profile response
// (the nudge Lambda writes `inAppNudge` onto the PROFILE row). No new API routes.
// Dismiss is tracked in localStorage['nudgeDismissed:<id>'].
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export default function NudgeBanner() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isConfigured = useAuthStore((s) => s.isConfigured);
  const [nudge, setNudge] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!isAuthenticated || !isConfigured) {
      setNudge(null);
      return;
    }
    (async () => {
      try {
        // silent: never toast an error just for the nudge probe
        const profile = await profileApi.get({ silent: true });
        const n = profile?.inAppNudge;
        if (cancelled || !n || !n.id) return;
        const fresh = n.createdAt && Date.now() - n.createdAt < THIRTY_DAYS_MS;
        if (!fresh) return;
        if (localStorage.getItem(`nudgeDismissed:${n.id}`)) return;
        setNudge(n);
      } catch {
        // non-fatal — the banner is best-effort
      }
    })();
    return () => { cancelled = true; };
  }, [isAuthenticated, isConfigured]);

  if (!nudge) return null;

  const dismiss = () => {
    try { localStorage.setItem(`nudgeDismissed:${nudge.id}`, '1'); } catch {}
    setNudge(null);
  };

  return (
    <div className="nudge-banner" role="status">
      <div className="nudge-banner-icon" aria-hidden="true">
        <Sparkles size={18} />
      </div>
      <div className="nudge-banner-content">
        {nudge.title && <div className="nudge-banner-title">{nudge.title}</div>}
        {nudge.body && <div className="nudge-banner-body">{nudge.body}</div>}
      </div>
      <button className="nudge-banner-close" onClick={dismiss} aria-label="Dismiss">
        <X size={18} />
      </button>
    </div>
  );
}
